import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { EmptyCoroutineContext_instance101eax45qp7ot as EmptyCoroutineContext_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/CoroutineContextImpl.mjs';
import { handleCoroutineExceptionv1m1bdk4j2te as handleCoroutineException } from '../CoroutineExceptionHandler.mjs';
import {
  safeIsDispatchNeeded2sl03dqd165wc as safeIsDispatchNeeded,
  safeDispatch2vco9v5u7w5xs as safeDispatch,
} from './DispatchedContinuation.mjs';
import { Runnablezd7bpy5et5p0 as Runnable } from '../Runnable.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { CoroutineDispatcherizb7p9bijexj as CoroutineDispatcher } from '../CoroutineDispatcher.mjs';
import { Delay9umexudtwyie as Delay } from '../Delay.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { get_DefaultDelay3q9fawcutqbnw as get_DefaultDelay } from '../CoroutineContext.mjs';
import { atomic$int$11d5swdyn6j0pu as atomic$int$1 } from '../../../../kotlinx-atomicfu/kotlinx/atomicfu/AtomicFU.mjs';
import { LockFreeTaskQueue36fqk9kdm4om8 as LockFreeTaskQueue } from './LockFreeTaskQueue.mjs';
import { SynchronizedObject32xqzf15iiskd as SynchronizedObject } from './Synchronized.mjs';
import { NamedDispatcher2rg47sbefduxc as NamedDispatcher } from './NamedDispatcher.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function checkParallelism(_this__u8e3s4) {
  // Inline function 'kotlin.require' call
  if (!(_this__u8e3s4 >= 1)) {
    var message = 'Expected positive parallelism level, but got ' + _this__u8e3s4;
    throw IllegalArgumentException().n2(toString(message));
  }
  return Unit_instance;
}
function tryAllocateWorker($this) {
  // Inline function 'kotlinx.coroutines.internal.synchronized' call
  // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
  $this.i1i_1;
  if ($this.g1i_1.kotlinx$atomicfu$value >= $this.e1i_1)
    return false;
  $this.g1i_1.atomicfu$incrementAndGet();
  return true;
}
function obtainTaskOrDeallocateWorker($this) {
  while (true) {
    var nextTask = $this.h1i_1.rj();
    if (nextTask == null) {
      // Inline function 'kotlinx.coroutines.internal.synchronized' call
      // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
      $this.i1i_1;
      $this.g1i_1.atomicfu$decrementAndGet();
      if ($this.h1i_1.q2() === 0)
        return null;
      $this.g1i_1.atomicfu$incrementAndGet();
    } else
      return nextTask;
  }
}
var WorkerClass;
function Worker() {
  if (WorkerClass === VOID) {
    class $ {
      constructor($outer, currentTask) {
        this.l1i_1 = $outer;
        this.k1i_1 = currentTask;
      }
      l11() {
        try {
          var fairnessCounter = 0;
          while (true) {
            try {
              this.k1i_1.l11();
            } catch ($p) {
              if ($p instanceof Error) {
                var e = $p;
                handleCoroutineException(EmptyCoroutineContext_instance, e);
              } else {
                throw $p;
              }
            }
            var tmp = this;
            var tmp0_elvis_lhs = obtainTaskOrDeallocateWorker(this.l1i_1);
            var tmp_0;
            if (tmp0_elvis_lhs == null) {
              return Unit_instance;
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }
            tmp.k1i_1 = tmp_0;
            var tmp_1;
            fairnessCounter = fairnessCounter + 1 | 0;
            if (fairnessCounter >= 16) {
              tmp_1 = safeIsDispatchNeeded(this.l1i_1.d1i_1, this.l1i_1);
            } else {
              tmp_1 = false;
            }
            if (tmp_1) {
              safeDispatch(this.l1i_1.d1i_1, this.l1i_1, this);
              return Unit_instance;
            }
          }
        } catch ($p) {
          if ($p instanceof Error) {
            var e_0 = $p;
            // Inline function 'kotlinx.coroutines.internal.synchronized' call
            // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
            this.l1i_1.i1i_1;
            this.l1i_1.g1i_1.atomicfu$decrementAndGet();
            throw e_0;
          } else {
            throw $p;
          }
        }
      }
    }
    initMetadataForClass($, 'Worker', VOID, VOID, [Runnable()]);
    WorkerClass = $;
  }
  return WorkerClass;
}
var LimitedDispatcherClass;
function LimitedDispatcher() {
  if (LimitedDispatcherClass === VOID) {
    class $ extends CoroutineDispatcher() {
      constructor(dispatcher, parallelism, name) {
        super();
        var tmp = this;
        var tmp0_elvis_lhs = isInterface(dispatcher, Delay()) ? dispatcher : null;
        tmp.c1i_1 = tmp0_elvis_lhs == null ? get_DefaultDelay() : tmp0_elvis_lhs;
        this.d1i_1 = dispatcher;
        this.e1i_1 = parallelism;
        this.f1i_1 = name;
        this.g1i_1 = atomic$int$1(0);
        this.h1i_1 = new (LockFreeTaskQueue())(false);
        this.i1i_1 = new (SynchronizedObject())();
      }
      n12(parallelism, name) {
        checkParallelism(parallelism);
        if (parallelism >= this.e1i_1)
          return namedOrThis(this, name);
        return super.n12(parallelism, name);
      }
      p12(context, block) {
        $l$block_1: {
          // Inline function 'kotlinx.coroutines.internal.LimitedDispatcher.dispatchInternal' call
          this.h1i_1.m1i(block);
          if (this.g1i_1.kotlinx$atomicfu$value >= this.e1i_1) {
            break $l$block_1;
          }
          if (!tryAllocateWorker(this)) {
            break $l$block_1;
          }
          var tmp0_elvis_lhs = obtainTaskOrDeallocateWorker(this);
          var tmp;
          if (tmp0_elvis_lhs == null) {
            break $l$block_1;
          } else {
            tmp = tmp0_elvis_lhs;
          }
          var task = tmp;
          try {
            var worker = new (Worker())(this, task);
            safeDispatch(this.d1i_1, this, worker);
          } catch ($p) {
            if ($p instanceof Error) {
              var e = $p;
              this.g1i_1.atomicfu$decrementAndGet();
              throw e;
            } else {
              throw $p;
            }
          }
        }
      }
      toString() {
        var tmp0_elvis_lhs = this.f1i_1;
        return tmp0_elvis_lhs == null ? this.d1i_1.toString() + '.limitedParallelism(' + this.e1i_1 + ')' : tmp0_elvis_lhs;
      }
      d13(timeMillis, continuation) {
        this.c1i_1.d13(timeMillis, continuation);
      }
      e13(timeMillis, block, context) {
        return this.c1i_1.e13(timeMillis, block, context);
      }
    }
    initMetadataForClass($, 'LimitedDispatcher', VOID, VOID, [Delay()], [1]);
    LimitedDispatcherClass = $;
  }
  return LimitedDispatcherClass;
}
function namedOrThis(_this__u8e3s4, name) {
  if (!(name == null))
    return new (NamedDispatcher())(_this__u8e3s4, name);
  return _this__u8e3s4;
}
//region block: exports
export {
  LimitedDispatcher as LimitedDispatcher3d39tn8ctj55l,
  checkParallelism as checkParallelism305j5epqg3ju0,
  namedOrThis as namedOrThis1pi8a62t67wtr,
};
//endregion

//# sourceMappingURL=LimitedDispatcher.mjs.map
